export const ItemTypes = {
    TABLE: 'table',
    TABLE_TOOLBOX: 'table_toolbox'
}